class ValidationStrategy {
  validate(file) {
    throw new Error("validate method must be implemented");
  }

  getHelpMessage() {
    throw new Error("getHelpMessage method must be implemented");
  }
}

export default ValidationStrategy;